import { TimelineLite } from 'gsap/TimelineLite';
import { TweenLite } from 'gsap/TweenLite';

import logoIn from '@/scripts/timelines/logo';
import { museletLoaderIn } from '@/scripts/timelines/museletTransitions';

import { qsa, qs } from '@/scripts/utils';

const loaderAnimation = (el, callback = () => {}) => {
  const tl = new TimelineLite();

  const musletTl = () => museletLoaderIn(el); // eslint-disable-line
  const logoTl = () => logoIn(el).play().timeScale(1.3); // eslint-disable-line
  const logoTlReverse = () => {
    const fun = logoIn(el);

    fun.eventCallback('onReverseComplete', () => {
      const logo = qs('.logo', el);
      const primaryText = qs('[js-introTextPrimary]', logo);
      const primaryLetters = qsa('[data-letter]', primaryText);
      const SecondaryText = qs('[js-introTextSecondary]', logo);
      const secondaryLetters = qsa('[data-letter]', SecondaryText);
      const paths = qsa('.cls-2', el);

      TweenLite.set(logo, { autoAlpha: 0 });
      TweenLite.set(primaryLetters, { clearProps: 'all' });
      TweenLite.set(secondaryLetters, { clearProps: 'all' });
      TweenLite.set(paths, { clearProps: 'all' });
      TweenLite.set(paths, { stroke: '#272727', strokeWidth: 15 });
      callback();
    });
    fun.progress(1, false).timeScale(1.3).reverse();
  };

  tl
    .add(musletTl)
    .add(logoTl, 1.4)
    .add(logoTlReverse, 2.9);
};

export default loaderAnimation;



// WEBPACK FOOTER //
// ./src/scripts/timelines/loaderAnimation.js